export default { // question id to useful context for ai agent
	"8ddfcda9-4e20-11f0-b336-01c0e8c53df5": `This is a math problem.`,

// 1376 + 259 = ? , Task 2 of Emma's Test Sequence
	"8ddfcda8-4e20-11f0-b336-01c0e8c53df5": `
This question is a fill in the blank question that asks the student what 1376 + 259 is.
The answer is 1635.
Misconceptions: Carrying / Wrong algorithm to carry out operation
Difficulty: introductory
Item type: short response/fill the blank
Tags: computation/3/4 digits
`,

	// 3 + 8 = _ + 6 , Task 1 of Emma's Test Sequence
	"8ddfcdb0-4e20-11f0-b336-01c0e8c53df5": `

This question is: "3 + 8 = _ + 6 ... What number goes in the blank to make the number sentence true?"
The answer is 5.
Misconceptions: Misunderstanding of symbols / Do not know how to start
Difficulty: easy
Item type: fill the blank
Tags: computation
`, 

	"8ddfcdad-4e20-11f0-b336-01c0e8c53df5": `This is a math problem.`,
	
	// 1,000 more than 56,821, task 5 of emma's test sequence
	"8ddfcda7-4e20-11f0-b336-01c0e8c53df5": `
This question asks the student to write the number that is 1,000 more than 56,821
Answer: 57821
Misconceptions: Operation translation / Misapplication of basic operation properties
`,
	"8ddfcdac-4e20-11f0-b336-01c0e8c53df5": `This is a math problem.`,
	"8ddfcdab-4e20-11f0-b336-01c0e8c53df5": `This is a math problem.`,

	// Juliana's Calculator, task 4 of emma's test sequence
	"8ddfcdaa-4e20-11f0-b336-01c0e8c53df5": `
This question is a multiple choice question that asks the student:
"Juanita wanted to use her calculator to add 1,379 and 243. She entered 1,279 + 243 by mistake. Which of these could she do to correct the mistake?"
The choices are: A) Add 100, B) Add 1, C) Subtract 1, and D) Subtract 100
The answer is A... 
Misconceptions: Didactic contract / Misapplication of basic operation properties
Difficulty: easy

`, 
	"8ddfcdaf-4e20-11f0-b336-01c0e8c53df5": `This is a math problem.`,
	"8ddfcda6-4e20-11f0-b336-01c0e8c53df5": `This is a math problem.`,
	"8ddfcdae-4e20-11f0-b336-01c0e8c53df5": `This is a math problem.`,

	// David's Meal, Take 3 of emma's test sequence
	"8ddfcdb1-4e20-11f0-b336-01c0e8c53df5": `
This question is a multiple choice question that asks the student:
"David wants to prepare a meal with 5 dishes using a stove with only 2 burners. The times needed to cook the 5 dishes are 40 min, 15 min, 35 min, 10 min and 45 min. What is the shortest time in which he can do it? (He may only remove a dish from the stove when it is done cooking.)"
The choices are: A) 60 min, B) 70 min, C) 75 min, D) 80 min, E) 85 min
Answer: C, 75 minutes
Misconceptions: Operation translation / Do not know how to start / Misreading / Didactic contract / Not recognizing associative and commutative properties
Difficulty: introductory
Item type: MCQ
Tags: computation/words to numbers/problem-solving
`,
}